import type { Mission, MissionRecord } from '@apos/shared';

/** Configuration and lifecycle events alone cannot reconstruct a shoot. */
export function hasReplayData(record: MissionRecord | null): boolean {
  if (!record) return false;
  return [record.aircraftObs, record.crewObs, record.cameraObs].some(streams => Object.values(streams).some(samples => samples.length > 0))
    || record.markers.length > 0 || record.mediaClips.length > 0;
}

/** Live shoots can review the recording so far without ending collection. */
export function canReplayShoot(status: Mission['status'] | undefined, record: MissionRecord | null): boolean { return (status === 'live' || status === 'ended') && hasReplayData(record); }
